export const data = [
  {
    'OWASP-ID': 'A1',
    'OWASP Name': 'Injection',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'OWASP-ID': 'A2',
    'OWASP Name': 'Broken Authentication',
    'NIST-ID': 'SC-23',
    Rev: 4,
    'NIST Name': 'Session Authenticity'
  },
  {
    'OWASP-ID': 'A3',
    'OWASP Name': 'Sensitive Data Exposure',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'OWASP-ID': 'A4',
    'OWASP Name': 'XML External Entities (XXE)',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'OWASP-ID': 'A5',
    'OWASP Name': 'Broken Access Control',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'OWASP-ID': 'A6',
    'OWASP Name': 'Security Misconfiguration',
    'NIST-ID': 'CM-6',
    Rev: 4,
    'NIST Name': 'Configuration Settings'
  },
  {
    'OWASP-ID': 'A7',
    'OWASP Name': 'Cross-Site Scripting (XSS)',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'OWASP-ID': 'A8',
    'OWASP Name': 'Insecure Deserialization',
    'NIST-ID': 'SC-23',
    Rev: 4,
    'NIST Name': 'Session Authenticity'
  },
  {
    'OWASP-ID': 'A9',
    'OWASP Name': 'Using Components with Known Vulnerabilities',
    'NIST-ID': 'SI-2',
    Rev: 4,
    'NIST Name': 'Flaw Remediation'
  },
  {
    'OWASP-ID': 'A10',
    'OWASP Name': 'Insufficient Logging&Monitoring',
    'NIST-ID': 'AU-12',
    Rev: 4,
    'NIST Name': 'Audit Generation'
  }
];
